import React from "react";
import { Link } from "react-router-dom";
import { SearchBar } from "./SearchBar";
/** style */
import { SearchForm } from '../style/Annuaire';
/** images */
import { Navbar } from '../Navbar';
import BackHeaderTop from "../components/BackHeaderTop";
import BackHeaderBottom from "../components/BackHeaderBottom";
import { PopupButton } from '@typeform/embed-react';
import Notaire from "../img/notaire-clotere.webp"


const HeaderAnnuaire2 = (args) => {
  return (
    <>
      <div className="relative rounded-4xl ">
        <BackHeaderTop />
        <div className="relative container">
          <Navbar />
          <div className="p-8 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 items-center">

            <div className="lg:pr-4">
              <div className="lg:max-w-lg">
                <h1 className="text-[40px] sm:text-[70px]  font-display  font-medium tracking-tight text-gray-950">
                  Trouvez <span className="text-indigo-800 font-semibold">votre notaire</span>
                </h1>
                <p className=" font-medium  sm:!text-[16px] tracking-[0] sm:leading-6">
                  Clotere vous permet de trouver le notaire qui vous convient, partout en France et de gérer votre dossier en ligne pour gagner du temps !
                </p>
                <SearchForm>
                  <SearchBar />
                </SearchForm><br/>
                <p>Les villes les plus recherchés</p>
                <div class="flex flex-row gap-2 flex-wrap justify-start">
                  <Link className="tag-recherche-notaire" to="/trouver/notaires/paris">Notaires à Paris</Link>
                  <Link className="tag-recherche-notaire" to="/trouver/notaires/lyon">Notaires à Lyon</Link>
                  <Link className="tag-recherche-notaire" to="/trouver/notaires/toulouse">Notaires à Toulouse</Link>
                </div>
              </div>
            </div>
            <div className="lg:pr-4">
              <img src={Notaire} alt="clotere" className={`mx-auto ${args.size === "small" ? "w-[70%]" : "sm:w-full w-[70%] mx-auto"}`} />
            </div>
          </div>

          

          {/** section liens rapides & question 
          <div className="pb-14 pt-0 sm:pb-22 sm:pt-14 md:pb-38 md:pt-22 text-center">
            <div className="flex sm:flex-row flex-col">
              <div className="flex-1">
                <p className="text-lg  mt-8 font-medium text-gray-950/75 ">
                  Trouvez votre notaire dans les grandes villes de France
                </p>
                <div class="flex flex-row gap-4 flex-wrap justify-center">
                  <Link className="tag-recherche-notaire" to="/fr/notaires/ville/paris">Notaires à Paris</Link>
                  <Link className="tag-recherche-notaire" to="/fr/notaires/ville/lyon">Notaires à Lyon</Link>
                  <Link className="tag-recherche-notaire" to="/fr/notaires/ville/toulouse">Notaires à Toulouse</Link>
                </div>
              </div>

              <div className="flex-1">
                <p className="text-lg  mt-8 font-medium text-gray-950/75 text-center">
                  Posez directement votre question à un notaire
                </p>
                <div class="flex flex-row gap-4 flex-wrap justify-center">
                  <PopupButton
                    id="cDphxVXu"
                    size={100}
                    autoClose={false}
                    style={{ border: '0' }}
                    hidden={{ idnotaire: "empty" }}
                  >
                    <button className='btn-main no-underline bg-gradient-to-r from-indigo-300 to-indigo-800'>👋 Posez votre question</button>
                  </PopupButton>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
        <BackHeaderBottom />
      </div>
    </>
    // End hero-banner-three
  );
};

export default HeaderAnnuaire2;
